<template>
    <div class="expense-info-step">
        <div class="expense-info-step__content">
            <div class="expense-info-step__form">
                <div class="expense-info-step__fields">
                    <div class="expense-info-step__field">
                        <label for="start_date">Start Date</label>
                        <themed-date-picker
                            id="start_date"
                            :value="expense.start_date"
                            @input="updateField('start_date', $event)"
                            :error="Boolean(errors.start_date)"
                        />
                        <div v-if="errors.start_date" class="expense-info-step__error">
                            {{ errors.start_date[0] }}
                        </div>
                    </div>

                    <div class="expense-info-step__field">
                        <label for="end_date">End Date</label>
                        <themed-date-picker
                            id="end_date"
                            :value="expense.end_date"
                            @input="updateField('end_date', $event)"
                            :error="Boolean(errors.end_date)"
                        />
                        <div v-if="errors.end_date" class="expense-info-step__error">
                            {{ errors.end_date[0] }}
                        </div>
                    </div>

                    <div class="expense-info-step__field">
                        <label for="type">Type</label>
                        <themed-select
                            id="type"
                            :value="expense.type_id"
                            :options="typeOptions"
                            @input="handleTypeChange"
                            placeholder="Select type"
                            :error="Boolean(errors.type_id)"
                        />
                        <div v-if="errors.type_id" class="expense-info-step__error">
                            {{ errors.type_id[0] }}
                        </div>
                    </div>

                    <div class="expense-info-step__field">
                        <label for="frequency">Frequency</label>
                        <themed-select
                            id="frequency"
                            :value="expense.frequency"
                            :options="frequencyOptions"
                            @input="updateField('frequency', $event)"
                            placeholder="Select frequency"
                            :error="Boolean(errors.frequency)"
                        />
                        <div v-if="errors.frequency" class="expense-info-step__error">
                            {{ errors.frequency[0] }}
                        </div>
                    </div>

                    <div class="expense-info-step__field">
                        <label for="amount">Amount <span v-if="expense.frequency" class="expense-info-step__label-hint">({{ expense.frequency === 'PSF' ? '$ per sq ft' : '$ ' + expense.frequency.toLowerCase() }})</span></label>
                        <themed-currency-input
                            id="amount"
                            :value="expense.amount_in_dollars"
                            @input="updateField('amount_in_dollars', $event)"
                            :is-decimal="true"
                            :error="Boolean(errors.amount)"
                        />
                        <div v-if="errors.amount" class="expense-info-step__error">
                            {{ errors.amount[0] }}
                        </div>
                    </div>
                </div>

                <div class="expense-info-step__note">
                    <themed-textarea
                        :value="expense.note"
                        @input="updateField('note', $event)"
                        placeholder="Expense Notes"
                        :rows="5"
                    />
                </div>
            </div>

            <div class="expense-info-step__toggles">
                <div class="expense-info-step__toggle">
                    <label>Liability</label>
                    <themed-toggle
                        :value="Boolean(expense.is_liability)"
                        @input="updateField('is_liability', $event ? 1 : 0)"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ThemedDatePicker from '../../form/ThemedDatePicker.vue';
import ThemedSelect from '../../ThemedSelect.vue';
import ThemedCurrencyInput from '../../form/ThemedCurrencyInput.vue';
import ThemedTextarea from '../../form/ThemedTextarea.vue';
import ThemedToggle from '../../ThemedToggle.vue';

export default {
    name: 'ExpenseInfoStep',

    components: {
        ThemedDatePicker,
        ThemedSelect,
        ThemedCurrencyInput,
        ThemedTextarea,
        ThemedToggle
    },

    props: {
        expense: {
            type: Object,
            required: true
        },
        expenseTypes: {
            type: Array,
            default: () => []
        },
        errors: {
            type: Object,
            default: () => ({})
        }
    },

    computed: {
        typeOptions() {
            return this.expenseTypes.map(type => ({
                value: type.id,
                label: type.name
            }));
        },

        frequencyOptions() {
            return [
                { value: 'PSF', label: 'PSF' },
                { value: 'Monthly', label: 'Monthly' },
                { value: 'Quarterly', label: 'Quarterly' },
                { value: 'Annual', label: 'Annual' },
                { value: 'Semi-Annual', label: 'Semi-Annual' },
                { value: 'One Time', label: 'One Time' }
            ];
        }
    },

    methods: {
        updateField(field, value) {
            this.$emit('update:expense', { [field]: value });
        },

        handleTypeChange(typeId) {
            this.updateField('type_id', typeId);
            this.$emit('set-expense-type', typeId);
        }
    }
};
</script>
